/**
 * Mail App Commands
 */

export { mailAppCommands } from './v1';
